import React from 'react';

import CheckoutSummaryProduct from '../CheckoutSummaryProduct/CheckoutSummaryProduct';
import useCheckoutSummaryList from './useCheckoutSummaryList';
import { CartOfferedGift, CartProduct, CartSpecialOffer } from 'types/Cart';

import styles from './CheckoutSummaryList.module.scss';

export default function CheckoutSummaryList({
  products,
  gifts,
  specialOffers,
}: CheckoutSummaryList): JSX.Element {
  const { productList } = useCheckoutSummaryList(
    products,
    gifts,
    specialOffers
  );

  return (
    <div className={styles.container}>
      {productList.map(product => {
        return <CheckoutSummaryProduct key={product.sku} product={product} />;
      })}
    </div>
  );
}

type CheckoutSummaryList = {
  products: CartProduct[];
  gifts?: CartOfferedGift[];
  specialOffers?: CartSpecialOffer[];
};
